module.exports = __webpack_public_path__ + "static/media/info_icon.87764403.svg";